import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import {styles} from 'common/lib/styles';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.dialogTitleRoot} {...other}>
      <Typography variant="h5">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                <path d="M15.875 9C15.875 5.20304 12.797 2.125 9 2.125C5.20304 2.125 2.125 5.20304 2.125 9C2.125 12.797 5.20304 15.875 9 15.875C12.797 15.875 15.875 12.797 15.875 9ZM10.8081 6.30811C11.0522 6.06403 11.4478 6.06403 11.6919 6.30811C11.936 6.55218 11.936 6.94782 11.6919 7.19189L9.88379 9L11.6919 10.8081C11.936 11.0522 11.936 11.4478 11.6919 11.6919C11.4478 11.936 11.0522 11.936 10.8081 11.6919L9 9.88379L7.19189 11.6919C6.94782 11.936 6.55218 11.936 6.30811 11.6919C6.06403 11.4478 6.06403 11.0522 6.30811 10.8081L8.11621 9L6.30811 7.19189C6.06403 6.94782 6.06403 6.55218 6.30811 6.30811C6.55218 6.06403 6.94782 6.06403 7.19189 6.30811L9 8.11621L10.8081 6.30811ZM17.125 9C17.125 13.4873 13.4873 17.125 9 17.125C4.51269 17.125 0.875 13.4873 0.875 9C0.875 4.51269 4.51269 0.875 9 0.875C13.4873 0.875 17.125 4.51269 17.125 9Z" fill="#183649"/>
                </g>
            </svg>

        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
export default DialogTitle